module.exports = __webpack_public_path__ + "static/media/IMG_4553.89b64338.jpg";